import React from 'react'
import Typography from '@material-ui/core/Typography'

import './index.css'

const AboutMe = ({ repos }) => (
  <div className='Aboutme'>
    <Typography
      color='textPrimary'
      align='center'
      component='h3'
      gutterBottom
      variant='h3'
      style={{ width: '100%', margin: '2rem auto' }}
    >
      ¿Quién soy?
    </Typography>
    <Typography
      className='wow bounceIn'
      data-wow-duration='2s'
      component='p'
      variant='subtitle1'
      style={{ width: '100%' }}
    >
      Hola, mi nombre es Orlando, soy <strong>Desarrollador Web</strong> especializado en <strong>Go (Golang)</strong> y <strong>JavaScript</strong>. También docente, blogger, entusiasta del software libre y un friki de la informática a tiempo completo.
    </Typography>
    <Typography
      className='wow bounceIn'
      data-wow-duration='2s'
      component='p'
      variant='subtitle1'
      style={{ width: '100%' }}
    >
      Ahora que sabe un poco sobre mí, me gustaría saber sobre usted. Si puedo ayudarlo de alguna manera no dude en ponerse en contacto conmigo, el botón naranja no muerde, lo prometo. Estoy a su servicio.
    </Typography>
  </div>
)

export default AboutMe
